module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["wrap"],
    style: _vm.wrapStyle
  }, [(_vm.isShowIndicator) ? _c('div', {
    staticClass: ["select-area"],
    style: _vm.indicatorStyle
  }) : _vm._e(), (_vm.label) ? _c('text', {
    staticClass: ["item-label"],
    style: _vm.labelStyle
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('scroller', {
    ref: "scroller",
    staticClass: ["scroller"],
    style: _vm.scrollerStyle,
    appendAsTree: true,
    attrs: {
      "append": "tree",
      "offsetAccuracy": "10",
      "showScrollbar": false
    },
    on: {
      "touchstart": _vm.handleStart,
      "touchend": _vm.handleEnd,
      "scroll": _vm.scroll
    }
  }, _vm._l((_vm.calcListArray), function(item, index) {
    return _c('div', {
      key: index,
      ref: "item",
      refInFor: true
    }, [_c('text', {
      staticClass: ["list-item"],
      class: item['classes'],
      style: _vm.itemStyle
    }, [_vm._v(_vm._s(item.value))])])
  }))])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-fa42252a!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-scroll-picker/index.vue
// module id = 667
// module chunks = 0 1